/* eslint-disable linebreak-style */
import React from 'react';
const StepChangesToYourJourneyShared = () => (
  <ol>
    <li>
      Medical bills, including prescription information and receipts, medical records
    </li>
    <li>
      Passport showing names, locations and stamps, 1-94
    </li>
    <li>
      Proof of Travel - (Airline ticket stub/receipt)
    </li>
    <li>
      Any other relevant supporting documents
    </li>
  </ol>
);

export default StepChangesToYourJourneyShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.ChangesToYourJourney/components/StepChangesToYourJourneyShared.js